module.exports = __webpack_public_path__ + "img/bg_avatar_female_85.f198ef83.png";